import { useQuery } from '@apollo/client'
import { AllSitesDocument } from '../../generated/graphql'
import { SelectInput } from '../select-input'
import { useMemo } from 'react'
import { FieldValues, UseControllerProps } from 'react-hook-form'

type Props = {
  label?: string
  defaultOptionLabel?: string
}

export const SitesInput = <TFieldValues extends FieldValues>(
  props: Props & UseControllerProps<TFieldValues>,
) => {
  const { name, control } = props

  const { data, loading } = useQuery(AllSitesDocument, {
    fetchPolicy: 'cache-and-network',
  })

  const options = useMemo(
    () => [
      ...(props.defaultOptionLabel
        ? [{ name: props.defaultOptionLabel, value: null }]
        : []),

      ...(data?.allSites || []).map((site) => ({
        name: `#${site.eshopid} ${site.eshopname}`,
        value: site.eshopid,
      })),
    ],
    [data?.allSites, props.defaultOptionLabel],
  )

  return (
    <SelectInput
      name={name}
      control={control}
      options={options}
      disabled={loading}
      label={props.label}
      slotProps={{ select: { displayEmpty: true } }}
    />
  )
}
